import { render, staticRenderFns } from "./EmailRoute.vue?vue&type=template&id=95980ab2&"
import script from "./EmailRoute.vue?vue&type=script&lang=js&"
export * from "./EmailRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports